import type { IAppsQueryVariables } from 'src/graphql/actions/apps/apps.query';
import type { SearchApplicationsQuery } from './types';

export const toAppsQueryVariables = (
  query: SearchApplicationsQuery,
): Pick<
  IAppsQueryVariables,
  | 'query'
  | 'productTypes'
  | 'certificationTypes'
  | 'unreadTasksExist'
  | 'needsFinishing'
  | 'productsExist'
  | 'owned'
  | 'unclaimed'
> => {
  const productTypes = query.filters.productIncluded;

  const certificationTypes = query.filters.assuranceReached;

  const unreadTasksExist =
    query.tab === 'unread_tasks' || query.filters.tasks?.includes('with_tasks')
      ? true
      : query.filters.tasks?.includes('all_clear')
        ? false
        : undefined;

  const needsFinishing = query.filters.setupStatus?.includes('needs_finishing') || undefined;

  const productsExist = query.filters.setupStatus?.includes('no_protection_yet') ? false : undefined;

  const owned = query.tab === 'your_applications' ? true : query.tab === 'vendor_applications' ? false : undefined;

  const unclaimed = query.tab === 'unclaimed' ? true : undefined;

  return {
    query: query.search || undefined,
    productTypes: productTypes?.length ? productTypes : undefined,
    certificationTypes: certificationTypes?.length ? certificationTypes : undefined,
    unreadTasksExist,
    needsFinishing,
    productsExist,
    owned,
    unclaimed,
  };
};
